// extracted by mini-css-extract-plugin
module.exports = {"notchedOutline":"SearchInput_notchedOutline__2FCWt","input":"SearchInput_input__3BrG4"};